module.exports = __webpack_public_path__ + "img/9valvulas.89a9ab56.jpg";